import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const AnimatedHeadline = ({ text, className, delay = 0 }) => {
  // Split text into words
  const words = text.split(' ');
  
  // Animation variants for container
  const container = {
    hidden: { opacity: 0 },
    visible: (i = 1) => ({
      opacity: 1,
      transition: { 
        staggerChildren: 0.12, 
        delayChildren: delay * 0.1,
      },
    }),
  };
  
  // Animation variants for each word
  const child = {
    hidden: {
      opacity: 0,
      y: 20,
      filter: "blur(5px)",
    },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100,
      },
    },
  };

  return (
    <StyledHeadline
      className={className}
      variants={container}
      initial="hidden"
      animate="visible"
    >
      {words.map((word, index) => (
        <motion.span key={index} variants={child} className="word">
          {word}&nbsp;
        </motion.span>
      ))}
    </StyledHeadline>
  );
};

const StyledHeadline = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  
  .word {
    display: inline-block;
    margin-right: 0.1rem;
    white-space: nowrap;
  }
`;

export default AnimatedHeadline;
